import { render, staticRenderFns } from "./FormItemRepeatableTable.vue?vue&type=template&id=5e1fef35&scoped=true"
import script from "./FormItemRepeatableTable.vue?vue&type=script&lang=js"
export * from "./FormItemRepeatableTable.vue?vue&type=script&lang=js"
import style0 from "./FormItemRepeatableTable.vue?vue&type=style&index=0&id=5e1fef35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fef35",
  null
  
)

export default component.exports